import { useState } from 'react';
import InputForm from '../../InputT';
import { useTranslation } from 'react-i18next';
import ParamsPicklist from '../../../Types/ParamsPicklist';
import DataType from '../../../Types/DataTablePiclist';
import { Backdrop, Box, CircularProgress, Grid, Tooltip } from '@mui/material';
import SearchInput from '../../SearchInput';
import SearchModal from '../../SearchModal';
import Table, { ColumnsType } from 'antd/es/table';
import { MonetizationOnOutlined, AttachMoneyOutlined, BookSharp, Delete } from '@mui/icons-material';
import Utilisateur from '../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../Services/Auth/sessionAuth';
import SweetAlert from 'sweetalert2';
import axios from 'axios';
import { Crypter } from '../../../Functions/Security/Crypter';
import Data from '../../../Data/Data.json';
import formatNumber from '../../../Functions/Traitement/FormatNumber';
import DataHistoCpt from '../../../Types/DataHistoCpt';
import ReformatDate from '../../../Functions/Traitement/ReformatDate';
import { Badge, Button, Form, Input, Space } from 'antd';

const Swal = require('sweetalert2');
let Link = require('../../../Data/Data.json');

const Tab1 = (props: { etatG?: boolean, form?: any, DataOperation: DataHistoCpt[], GetAllOperation: Function }) => {

  const datas: DataType[] = [];
  //const {t,i18n}=useTranslation();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Filtre, setFiltre] = useState<number>();
  const auth = useAuthUser()
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()))
  const authHeader = useAuthHeader();

  //Initialisation des parametres de recherche
  let searchRef: ParamsPicklist = { CodeAgence: user.codage, Table: "ECPTAMPON", Colonne1: "REPECE", Colonne2: "LIBELL",colfiltre:"UTISAI",valfiltre:user.coduti, Colagence: 'AEDUCP', Choix: 22 }
  let searchGestionnaire: ParamsPicklist = { CodeAgence: '', Table: "GESTIONNAIRE", Colonne1: "CODGES", Colonne2: "LIBELLE", Colagence: '001', Choix: 22 }
  let searchCompteEM: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "", Choix: 22 }
  let searchCompteRECEPT: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: "", Choix: 22 }

  const columns: ColumnsType<DataHistoCpt> = [
    {
      title: 'DateOpe',
      dataIndex: 'DATOPE',
      ellipsis: true,
      width: 100,
      render: (text: any, reccord: any) => (
        <span>
          {ReformatDate(text)}
        </span>
      )
    }, {
      title: 'Heure',
      dataIndex: 'TIME',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'N° Compte',
      dataIndex: 'NUMCPT',
      ellipsis: true,
      width: 200,
      // filteredValue: [SearchR],
      onFilter: (value: any, record: any) => {
        return String(record.NUMCPT)
          .toLowerCase()
          .includes(value.toLowerCase()) ||
          String(record.SENSEC)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.REPECE)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.MONTANT)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.LIBELL)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Utilis)
            .toLowerCase()
            .includes(value.toLowerCase()) ||
          String(record.Motif)
            .toLowerCase()
            .includes(value.toLowerCase())
      }
    },
    {
      title: 'Sens',
      dataIndex: 'SENSEC',
      ellipsis: true,
      align: 'center',
      width: 100,
      render: (text: any, reccord: any) => (
        <Box sx={{ alignItems: 'center' }} >
          <Badge style={{ textAlign: 'center' }} status='success' color={reccord.SENSEC == "C" ? 'green' : reccord.SENSEC == "D" ? 'red' : 'orange'} size='default' count={reccord.SENSEC == "D" ? 'Debit' : reccord.SENSEC == "C" ? 'Credit' : 'No sence'}> </Badge>
        </Box>
      )
    },
    {
      title: 'Reférence',
      dataIndex: 'REPECE',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'REFLIAI',
      dataIndex: 'REFLIAI',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Numrap',
      dataIndex: 'NUMRAP',
      ellipsis: true,
      width: 100,
    },
    {
      title: 'Montant',
      dataIndex: 'MONTANT',
      ellipsis: true,
      width: 150,
    },
    {
      title: 'Beneficiare',
      dataIndex: 'NBENEF',
      ellipsis: true,
      width: 200
    },
    {
      title: 'Utisai',
      dataIndex: 'UTISAI',
      ellipsis: true,
      width: 100
    },
    {
      title: 'Action',
      key: 'action',
      ellipsis: true,
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title='Retirer de la liste'>
            <Button disabled={false} color='error' icon={<Delete color='error' />} onClick={() => {
              handleDeleOperation(record.REPECE, record.REFLIAI ? record.REFLIAI : '');
            }} />
          </Tooltip>
        </Space>
      ),
    },
    {
      title: 'Libelle',
      dataIndex: 'LIBELL',
      ellipsis: true,
      width: 200
    },
    {
      title: "",
      dataIndex: 'RelObject',
      width: 1
    }
  ];

  let informationclient = {
    SearchRef: {
      Titre: "Recherche Service",
      label: "Réference",
      name: "Reference", params: searchRef
    },
    searchCodeOpeEM: {
      Titre: "Recherche Opération",
      label: "Operation Débit",
      name: "CodeOpeEm", params: searchGestionnaire
    },
    searchCompteEM: {
      Titre: "Recherche Compte Emetteur ",
      label: "Compte Debit",
      name: "NUMCPTEMT", params: searchCompteEM
    },
    searchCompteRECEPT: {
      Titre: "Recherche Compte Recepteur",
      label: "Compte Credit",
      name: "NUMCPTRECPT", params: searchCompteRECEPT
    },
    //Montant disponible pour l'emetteur
    InputDisponibleEM: {
      label: "Disponible",
      name: "DISPONEM"
    },
    //Montant disponible pour le recepteur
    InputDisponibleRECEPT: {
      label: "Disponible",
      name: "DISPONRECP"
    },
    searchCodeOpeRECPT: {
      Titre: "Recherche Opération",
      label: "Operation Crédit",
      name: "CodeOpeReCpt", params: searchGestionnaire
    },
    InputMontant: {
      label: "Montant",
      name: "Montant"
    },
    InputNumPiece: {
      label: "Numéro Pièce",
      name: "NumPiece"
    }
  }

  const handleChangeCompte = async () => {
    setLoading(true);
    let NUMCPT = '';
    NUMCPT = props.form.getFieldValue('NUMCPTEMT');

    let data = Crypter.encrypt(NUMCPT);

    props.form.setFieldsValue({ 'DISPONEM': '' })

    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetCompte,
      headers: {
        'CypherNumCpte': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let requestOne = axios.request(config1);

    if (NUMCPT.length != 0) {
      await axios
        .all([requestOne])
        .then(
          await axios.spread(async (...responses: any) => {

            const responseOne = responses[0];
            if (responseOne.data) {
              const res = JSON.parse(Crypter.decrypt(responseOne.data));
              if (res.StatutCode == 200) {
                let datas = res.Result.Table[0];
                if (res.Result.Table.length > 0) {
                  props.form.setFieldValue('lib_NUMCPTEMT', datas.NOMCPT);
                  props.form.setFieldValue('DISPONEM', formatNumber(datas.DISPON));
                } else {
                  SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
                }
              }
              else {
                setLoading(false);
                SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
              }
            }
          }
          )).catch((errors) => {
            SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
          });
    }
    setLoading(false);
  }


  const handleChangeCompteRecep = async () => {

    setLoading(true);
    let NUMCPT = '';
    NUMCPT = props.form.getFieldValue('NUMCPTRECPT');

    let data = Crypter.encrypt(NUMCPT);

    props.form.setFieldsValue({ "lib_NUMCPTRECPT": '', 'DISPONRECP': '', 'CodeOpeRECP': '', 'LibelleRecep': '' })

    let config1 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Data.ApiUrl.GetCompte,
      headers: {
        'CypherNumCpte': data,
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: Link.ApiUrl.GetGetCodeOperat,
      headers: {
        'CypherChampOpe': Crypter.encrypt('OPE009'),
        'Authorization': authHeader(),
        'Content-Type': 'application/json'
      },
    };

    let requestOne = axios.request(config1);
    let requestTwo = axios.request(config2);

    if (NUMCPT.length!=0) {
      await axios
        .all([requestOne, requestTwo])
        .then(
          await axios.spread(async (...responses: any) => {

            const responseOne = responses[0];
            const responseTwo = responses[1];
            if (responseOne.data) {
              const res = JSON.parse(Crypter.decrypt(responseOne.data));
              if (res.StatutCode == 200) {
                let datas = res.Result.Table[0];
                if (res.Result.Table.length > 0) {
                  props.form.setFieldValue('lib_NUMCPTRECPT', datas.NOMCPT);
                  props.form.setFieldValue('DISPONRECP', formatNumber(datas.DISPON));
                } else {
                  SweetAlert.fire({ title: "Warning", text: "Compte not found", icon: "warning" })
                }

                if (responseTwo.data) {
                  const res = JSON.parse(Crypter.decrypt(responseTwo.data)).Value;
                  if (res.StatutCode == 200) {
                    let datas = res.Result[0];
                    props.form.setFieldValue("LibelleRecep", datas.LIBELL + ' FAVEUR ' + props.form.getFieldValue("lib_NUMCPTRECPT"))
                  }
                  else {
                    setLoading(false);
                    SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
                  }
                }
              }
              else {
                setLoading(false);
                SweetAlert.fire({ title: "error", text: res.Message, icon: "error" })
              }
            }
          }
          )).catch((errors) => {
            SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
          });
    }
    setLoading(false);
  }


  const handleDeleOperation = async (Reference: string, NUMRAP: string) => {
    setLoading(true);
    SweetAlert.fire({
      title: "Suppression d'opération",
      text: "Voulez-vous Supprimer les Opérations de réference : " + Reference + " ? ",
      showCancelButton: true,
      color: "warning",
      confirmButtonText: "Yes",
      confirmButtonColor: "green",
      cancelButtonColor: "darkred",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
      icon: 'question'
    }).then((res) => {
      if (res.isConfirmed) {
        setLoading(true);
        var config = {
          method: 'delete',
          maxBodyLength: Infinity,
          url: Data.ApiUrl.DeleteOperation,
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader(),
            'CypherRepeclia': Crypter.encrypt(NUMRAP),
            'CypherCodeA': Crypter.encrypt(user.codage),
            'CypherCodeU': Crypter.encrypt(user.coduti),
            'CypherRepec': Crypter.encrypt(Reference)
          }
        }

        axios(config)
          .then((response) => {
            //alert('ok')
            if (response.data) {
              const res = JSON.parse(Crypter.decrypt(response.data)).Value;

              if (res.StatutCode == 200) {
                let datas = res.Result[0];
                if (datas.length === 0) {

                }
                else {
                  SweetAlert.fire({ title: datas.Column1, text: 'reference:' + Reference, icon: "success" });

                  props.GetAllOperation();
                }
              }
              else SweetAlert.fire({ title: 'Error ', text: res.Message, icon: "error" });
              setLoading(false);
            }
            //  setLoad(false);
          }).catch((error) => {
            setLoading(false);
            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
          })
      };
    })
      .catch((error) => {
        setLoading(false);
        console.log(error)
        SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
      });

    setLoading(false);
  }

  return (

    <div className='tabItem' >
      <div >
        <Box fontStyle="inherit" className='bordure1' width={"85%"} position={"absolute"}>
          <Box className='bordure1'  >
            <SearchInput dissabledCode={props.etatG}  Titre={informationclient.SearchRef.Titre} label={informationclient.SearchRef.label} name={informationclient.SearchRef.name} Parametre={informationclient.SearchRef.params} form={props.form} />
          </Box>
           <Box className='bordure1'  >
             <legend style={{marginTop:0, marginBottom:0, borderRadius:8,width:'100%'}}>Informations Débit</legend>
          <Grid container spacing={0}>
             <Grid item xs={12} md={8} lg={8}>
              <SearchInput width={3} dissabledCode dissabledLib={false} form={props.form}   Titre={informationclient.searchCodeOpeEM.Titre} label={informationclient.searchCodeOpeEM.label} name={informationclient.searchCodeOpeEM.name} Parametre={informationclient.searchCodeOpeEM.params} />
              <SearchModal width={3} handleFunction={handleChangeCompte} form={props.form} Titre={informationclient.searchCompteEM.Titre} label={informationclient.searchCompteEM.label} name={informationclient.searchCompteEM.name} Parametre={informationclient.searchCompteEM.params} />
             </Grid>
         
           <Grid item xs={12} md={4} lg={4}>
              <InputForm icon={<MonetizationOnOutlined />}  width={7} disabled label={informationclient.InputDisponibleEM.label} name={informationclient.InputDisponibleEM.name} type='text' />
              <InputForm money icon={<AttachMoneyOutlined />}  width={7} label={informationclient.InputMontant.label} name={informationclient.InputMontant.name} type='number' />
              {/* <InputForm label="Libelle " width={7} name='LibelleEm' type='TextArea' /> */}
           </Grid>
          </Grid>
         
            <legend style={{marginTop:0, marginBottom:0, borderRadius:8,width:'100%'}}>Informations Crédit</legend>
      
           <Grid container spacing={0}>
             <Grid item xs={12} md={8} lg={8}>
              <SearchInput width={3}  dissabledCode  form={props.form}  dissabledLib={false} Titre={informationclient.searchCodeOpeRECPT.Titre} label={informationclient.searchCodeOpeRECPT.label} name={informationclient.searchCodeOpeRECPT.name} Parametre={informationclient.searchCodeOpeRECPT.params} />
              <SearchModal width={3}  handleFunction={handleChangeCompteRecep} form={props.form} Titre={informationclient.searchCompteRECEPT.Titre} label={informationclient.searchCompteRECEPT.label} name={informationclient.searchCompteRECEPT.name} Parametre={informationclient.searchCompteRECEPT.params} />
              </Grid>
           <Grid item xs={12} md={4} lg={4}>
              <InputForm icon={<MonetizationOnOutlined />} width={7} disabled label={informationclient.InputDisponibleRECEPT.label} name={informationclient.InputDisponibleRECEPT.name} type='text' />
              <InputForm icon={<BookSharp />} width={7} label={informationclient.InputNumPiece.label} name={informationclient.InputNumPiece.name} type='text' />
            </Grid>
            </Grid>
     </Box>

        
          <Box className='bordure1' >
            <Table sticky={true} size='small' columns={columns} pagination={false} style={{ width: '100%' }} scroll={{ y: 200, x: 1200 }} dataSource={props.DataOperation} />
          </Box>
          <Box display={"flex"} width={"98%"} marginTop={"5px"} fontStyle="inherit">
            <Space.Compact >
              <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebitOP'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrCrebitOP'><Input disabled /></Form.Item>
            </Space.Compact>
            <Space.Compact >
              <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebitOP'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrdebitOP'><Input disabled /></Form.Item>
            </Space.Compact>
            <Space.Compact >
              <Form.Item label="Solde Total" name='SoldeOP'><Input disabled /></Form.Item>
            </Space.Compact>
          </Box>
        </Box>
        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
    </div>
  );
}
export default Tab1;
